import { render, staticRenderFns } from "./EmailConfirmReg.vue?vue&type=template&id=0272e7cf&scoped=true&"
import script from "./EmailConfirmReg.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmReg.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmReg.vue?vue&type=style&index=0&id=0272e7cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272e7cf",
  null
  
)

export default component.exports